module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    staticClass: "comp-reword-config",
    attrs: {
      "title": "转发悬赏",
      "visible": _vm.visible
    },
    on: {
      "update:visible": function($event) {
        _vm.visible = $event
      },
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "desc"
  }, [_vm._v("温馨提示：系统通过大数据技术将企业转发悬赏招聘岗位信息推送给用户，用户通过扩散转发来帮助企业提升招聘曝光量，最后企业根据转发次数结算佣金。")]), _vm._v(" "), _c('div', {
    staticClass: "content-box"
  }, [_c('div', {
    staticClass: "content-item flex align-start"
  }, [_c('div', {
    staticClass: "left-tit"
  }, [_vm._v("请选择转发模式")]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "mode flex"
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("全体转发")]), _vm._v(" "), _c('span', {
    staticClass: "sub-text"
  }, [_vm._v("全体用户均可参与，曝光范围广")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mode"
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "disabled": "",
      "label": 2
    },
    model: {
      value: (_vm.type),
      callback: function($$v) {
        _vm.type = $$v
      },
      expression: "type"
    }
  }, [_vm._v("精准转发")]), _vm._v(" "), _c('span', {
    staticClass: "sub-text"
  }, [_vm._v("仅求职期望一致的用户转发有效，曝光群体更精准")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "content-item flex align-start"
  }, [_c('div', {
    staticClass: "left-tit"
  }, [_vm._v("单个用户浏览佣金")]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "sub-text"
  }, [_vm._v("转发的岗位在被其他人查看后，转发人将获得的相应的佣金")]), _vm._v(" "), _c('div', [_c('el-input-number', {
    staticClass: "input-amount",
    attrs: {
      "min": 0.1,
      "max": 1000
    },
    model: {
      value: (_vm.singleAmount),
      callback: function($$v) {
        _vm.singleAmount = $$v
      },
      expression: "singleAmount"
    }
  }), _c('span', {
    staticClass: "unit"
  }, [_vm._v("元")])], 1), _vm._v(" "), _c('div', {
    staticClass: "sub-text"
  }, [_vm._v("单次浏览最低0.1元起/精准转发最低2.0起，转发访问单个用户重复浏览不计算费用")])])]), _vm._v(" "), _c('div', {
    staticClass: "content-item flex align-start"
  }, [_c('div', {
    staticClass: "left-tit"
  }, [_vm._v("转发悬赏结束日期")]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "选择日期",
      "picker-options": _vm.pickerOptions0,
      "format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.planEndAt),
      callback: function($$v) {
        _vm.planEndAt = $$v
      },
      expression: "planEndAt"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "sub-text"
  }, [_vm._v("选择的日期晚上12点过后结束悬赏结算")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content-item flex align-start"
  }, [_c('div', {
    staticClass: "left-tit"
  }, [_vm._v("转发悬赏总预算")]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', [_c('el-input', {
    staticClass: "input-amount-2",
    attrs: {
      "placeholder": "请输入转发预算总金额"
    },
    model: {
      value: (_vm.amount),
      callback: function($$v) {
        _vm.amount = $$v
      },
      expression: "amount"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "unit"
  }, [_vm._v("元")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "content-item flex align-start"
  }, [_c('div', {
    staticClass: "left-tit"
  }, [_vm._v("预算超支控制")]), _vm._v(" "), _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    },
    model: {
      value: (_vm.overspend),
      callback: function($$v) {
        _vm.overspend = $$v
      },
      expression: "overspend"
    }
  }, [_vm._v("允许超支")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    },
    model: {
      value: (_vm.overspend),
      callback: function($$v) {
        _vm.overspend = $$v
      },
      expression: "overspend"
    }
  }, [_vm._v("不允许超支")])], 1), _vm._v(" "), _c('span', {
    staticClass: "sub-text m-t-13"
  }, [_vm._v("允许超支将会在可用余额用完时停止发放佣金")])])]), _vm._v(" "), _c('el-button', {
    staticClass: "btn",
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确定开通转发悬赏")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e0f242a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reword/Config.vue
// module id = 890
// module chunks = 1